module.exports = __webpack_public_path__ + "img/GALLERY-VITARA-5.4aa2f0de.jpg";